export function currentHost(): string {
  return window.location.host.split(':')[0]?.toLowerCase() ?? '';
}
